import React from 'react'
import * as pym from 'pym.js'
import Img from "gatsby-image";


class MapImg extends React.Component {
  render () {
    return (
      <div className="img-column">
        <h2>{this.props.title}</h2>

        {this.props.scale}

        <div className="map-wrapper">

          <div className="state-img">
            <Img
              title={this.props.title}
              alt={"Map of " + this.props.titles}
              sizes={this.props.stateImg.sizes}
            />
            <div className="city-label chicago-label">
              Chicago
            </div>
            <div className="city-label sm-city-label springfield-label">
              Springfield
            </div>
          </div>
          <div className="cook-img">
            <Img
              title={this.props.title}
              alt={"Map of " + this.props.title}
              sizes={this.props.cookImg.sizes}
            />
          </div>

        </div>

      </div>
    )
  }
}


class GradientScale extends React.Component {
  render() {
    return (
      <div className="gradient-scale">
        <span>{this.props.min}</span>
        <span className={"gradient " + this.props.gradientClass} />
        <span>{this.props.max}</span>
      </div>
    )
  }
}


class IndexPage extends React.Component {

  // @TODO can / should this be moved to a layout component?
  componentDidMount() {
    this.pymChild = new pym.Child({polling: 500})
  }

  render() {
    return (
      <div className="pg-graphic">
        <div className="graphic-wrapper">
          <div className="img-col state-img-col">
            <h2>License suspensions for unpaid tickets in Illinois are concentrated in Chicago.</h2>
            <div className="img-wrapper">
              <Img
                title={"Illinois license suspensions"}
                alt={"Map of license suspensions in Illinois (statewide)"}
                sizes={this.props.data.stateSuspensionsImage.sizes}
              />
              <span className="city-label chicago-label">Chicago</span>
            </div>
            <GradientScale
              min={<span>1 <span className="hidden">suspension</span></span>}
              max="725 suspensions"
              gradientClass="gradient-red" />
          </div>
          <div className="img-col county-img-col">
            <h2>In Chicago, they're concentrated on the city's South and West sides.</h2>
            <div className="cook-img">
              <Img
                title={"Chicago license suspensions"}
                alt={"Map of license suspensions in Chicago metro"}
                sizes={this.props.data.cookSuspensionsImage.sizes}
              />
            </div>
            <GradientScale
              min={<span>1 <span className="hidden">suspension</span></span>}
              max="725 suspensions"
              gradientClass="gradient-red" />
            <h2>These neighborhoods are mostly black.</h2>
            <div className="cook-img">
              <Img
                title={"Chicago % black zipcodes"}
                alt={"Map of black population in Chicago metro"}
                sizes={this.props.data.cookPctBlackImage.sizes}
              />
            </div>
            <GradientScale
              min={<span>0% <span className="hidden">black</span></span>}
              max="98% black"
              gradientClass="gradient-blue"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default IndexPage

export const query = graphql`
  query ImageQuery {
    cookPctBlackImage: imageSharp(id: { regex: "/cook-pct-black/" }) {
      sizes(maxWidth: 700 ) {
        ...GatsbyImageSharpSizes
      }
    }
    cookSuspensionsImage: imageSharp(id: { regex: "/cook-suspensions/" }) {
      sizes(maxWidth: 700 ) {
        ...GatsbyImageSharpSizes
      }
    }
    stateSuspensionsImage: imageSharp(id: { regex: "/state-suspensions/" }) {
      sizes(maxWidth: 700 ) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/child/index.js